import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import './MyProfils.css';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination'; 
import ActionButtons from '../../commun/ActionButtons';
import ModalButton from '../../commun/ModalButton';
import FormInputMUI from '../../commun/FormInputMUI';
import { showDeleteConfirmation } from '../../commun/deletemsg';

const MyProfils = () => {
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [displayMode, setDisplayMode] = useState('table');

  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const recruteurName = localStorage.getItem("recruteurName");

  const [profils, setProfils] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ remarque: '', status: '', tarif: '' });
  const [selected, setSelected] = useState([]);

  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  // Modal state for adding new profile
  const [showModal, setShowModal] = useState(false);
  const [remarque, setRemarque] = useState('');
  const [status, setStatus] = useState('Disponible');
  const [tarif, setTarif] = useState('');
  const [cvFile, setCvFile] = useState(null);

  const paginatedProfils = profils.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  useEffect(() => {
    if (!authToken) return navigate('/');
    fetchProfils();
  }, [authToken, navigate]);

  const fetchProfils = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/recruteur/profil?recruteurId=${userId}`);
      const data = await res.json();
      setProfils(data);
    } catch (err) {
      console.error("Erreur de chargement des profils :", err);
    }
  };

  const handleEditClick = (row) => {
    setEditingId(row._id);
    setEditForm({
      remarque: row.remarque || '',
      status: row.status || 'Disponible',
      tarif: row.tarif ? parseFloat(row.tarif) : ''
    });
  };

  const handleEditSave = async (id) => {
    try {
      const formData = new FormData();
      formData.append("remarque", editForm.remarque);
      formData.append("status", editForm.status);
      formData.append("tarif", editForm.tarif);

      const res = await fetch(`${API_BASE}/api/recruteur/update-profil/${id}`, {
        method: 'PUT',
        body: formData
      });

      if (!res.ok) throw new Error('Échec de la mise à jour');

      await fetchProfils();
      setEditingId(null);
    } catch (err) {
      console.error(err);
      alert("Erreur de mise à jour");
    }
  };

  const handleEditCancel = () => {
    setEditingId(null);
    setEditForm({ remarque: '', status: '', tarif: '' });
  };
  const handleDeleteProfil = (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          const res = await fetch(`${API_BASE}/api/recruteur/delete-profil/${id}`, {
            method: 'DELETE',
          });
          if (!res.ok) throw new Error("Échec de la suppression");
          await fetchProfils(); 
        } catch (error) {
          console.error("Erreur lors de la suppression :", error);
          alert("Erreur lors de la suppression");
        }
      },
      onCancel: () => {},
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!cvFile) return alert("Veuillez joindre un CV.");

    const formData = new FormData();
    formData.append("remarque", remarque);
    formData.append("status", status);
    formData.append("tarif", tarif);
    formData.append("cvFile", cvFile);
    formData.append("recruteurId", userId);

    try {
      const res = await fetch(`${API_BASE}/api/recruteur/createprofil`, {
        method: "POST",
        body: formData
      });

      if (!res.ok) throw new Error("Erreur lors de la création");

      await fetchProfils();
      resetForm();
    } catch (error) {
      console.error("Erreur lors de la soumission :", error);
      alert(error.message);
    }
  };

  const resetForm = () => {
    setShowModal(false);
    setRemarque('');
    setStatus('Disponible');
    setTarif('');
    setCvFile(null);
  };

  const columns = [
    {
      key: 'reference',
      label: 'Référence',
      render: (value) => value || '—'
    },
    {
      key: 'remarque',
      label: 'Remarque',
      render: (value, row) =>
        editingId === row._id ? (
          <input
            type="text"
            value={editForm.remarque}
            onChange={(e) => setEditForm({ ...editForm, remarque: e.target.value })}
          />
        ) : (
          value || '—'
        )
    },
    {
      key: 'tarif',
      label: 'Tarif (€)',
      render: (value, row) =>
        editingId === row._id ? (
          <input
            type="number"
            value={editForm.tarif}
            onChange={(e) => setEditForm({ ...editForm, tarif: e.target.value })}
          />
        ) : (
          value ? `${value} €` : '—'
        )
    },
    {
      key: 'status',
      label: 'Statut',
      render: (value, row) =>
        editingId === row._id ? (
          <select
            value={editForm.status}
            onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
          >
            <option value="Disponible">Disponible</option>
            <option value="Indisponible">Indisponible</option>
          </select>
        ) : (
          value
        )
    }
  ];

  return (
    <div className="myprofils-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />

      <main className="myprofils-container">
        <h3 className="componentTitle">Mes Profils</h3>
        {/*<ModalButton label="Ajouter un profil" onClick={() => setShowModal(true)} /> */}

        <div className="tableWrapper">
          <GenericTable
            columns={columns}
            data={paginatedProfils}
            selectedRows={selected}
            setSelectedRows={setSelected}
            onDeleteSelected={(selectedIds) => {
              showDeleteConfirmation({
                message: `Supprimer ${selectedIds.length} profil(s) ?`,
                onConfirm: async () => {
                  try {
                    await Promise.all(
                      selectedIds.map(id =>
                        fetch(`${API_BASE}/api/recruteur/delete-profil/${id}`, { method: 'DELETE' })
                      )
                    );
                    setProfils(prev => prev.filter(t => !selectedIds.includes(t._id)));
                    setSelected([]);
                  } catch (error) {
                    console.error('Erreur lors de la suppression en masse :', error);
                    alert('Erreur lors de la suppression');
                  }
                },
                onCancel: () => {},
              });
            }}            
            renderActions={(row) => (
              <ActionButtons
              isEditing={editingId === row._id}
              showView={false}
              showDownload={!!row.cvFile}
              showDelete={true}
              onDownload={
                row.cvFile
                  ? () => {
                      const link = document.createElement('a');
                      link.href = `${API_BASE}/uploads/cv/${row.cvFile}`;
                      link.download = '';
                      link.target = '_blank';
                      link.click();
                    }
                  : undefined
              }
              onEdit={() => handleEditClick(row)}
              onSave={() => handleEditSave(row._id)}
              onCancel={handleEditCancel}
              onDelete={() => handleDeleteProfil(row._id)}
              displayMode={displayMode}           
             setDisplayMode={setDisplayMode}
            />
            )}
          />

          <Pagination page={page} setPage={setPage} totalItems={profils.length} />
        </div>

        {showModal && (
          <div className="myprofils-modal-overlay">
            <div className="myprofils-modal">
              <h3>Ajouter un profil</h3>
              <form onSubmit={handleSubmit}>
                <FormInputMUI
                  label="Remarque"
                  multiline
                  value={remarque}
                  onChange={setRemarque}
                />

                <FormInputMUI
                  label="Statut *"
                  value={status}
                  onChange={setStatus}
                  select
                  options={[
                    { value: 'Disponible', label: 'Disponible' },
                    { value: 'Indisponible', label: 'Indisponible' },
                  ]}
                />

                <FormInputMUI
                  label="Tarif (€) *"
                  type="number"
                  value={tarif}
                  onChange={setTarif}
                />

                <FormInputMUI
                  label="CV (PDF)"
                  type="file"
                  value={cvFile}
                  onChange={setCvFile}
                  accept="application/pdf"
                />

                <div className="myprofils-modal-actions">
                  <button type="button" onClick={resetForm} className="cancel-btn">
                    Annuler
                  </button>
                  <button type="submit" className="confirm-btn">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default MyProfils;
